/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0,500;0,700;1,400&display=swap);.contact-table{background:#fff;padding:0}.details-back{padding:0 0 1.5rem;text-align:right;display:flex;justify-content:flex-end;align-items:center}.details-back button.button-back{margin-right:1rem}.details-back button.button-back:not([disabled]):hover{box-shadow:inset 0 -10rem 0 rgba(158,158,158,.2)}.details-back button.button-back:hover{background:#21d196;color:#fff;text-decoration:none;cursor:pointer;transition:background .4s}"];
export { styles as styles };
